import React from 'react';
import loadingIcon from '../../../../images/gifs/loadingIcon.gif';

const LoadingGif = () => (<><img  src={loadingIcon} height="100px" width="100px" style={{margin: '0 auto'}} alt='loading' /></>)

export default LoadingGif;